<template>
  <div v-loading="isLoading" class="cs-workflowDetails-container" ref="workflowDetailsContainer">
    <el-row>
      <el-col class="cs-workflowDetails-title"><span class="cs-title">上次退课报名信息</span></el-col>
    </el-row>
    <el-row class="cs-workflowDetails-discounts">
      <el-col :span="18">优惠:{{discountNames}}</el-col>
      <el-col :span="6" class="align-right">
        <el-button size="mini" type="primary" @click="onCopyInfo">复制退课信息</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="cs-workflowDetails-courseEnrollmentList">
        <courseEnrollmentList ref="courseEnrollmentList" :bonusPointDisabled="true" :courseType="courseType" :bonusPoint="0"
          :isVerticalAlign="true" :priceSettings="dataIn.priceSettings" :isReadonly="true" :dataIn="courseListData"
          :studentId="dataIn.memberModel.StudentId">
        </courseEnrollmentList>
      </el-col>
    </el-row>
    <el-row class="cs-workflowDetails-workflowCostInfo" ref="workflowCostInfo">
      <el-col>
        <el-row>
          <el-col :span="12">
            <span>课程总价: </span>
            <span>{{ dataIn.workflowData.CourseDiscountTotalPrice | toCurrency}}</span>
          </el-col>
        </el-row>
        <el-row v-if="!!dataIn.workflowData.WorkflowRelatedDicountAmount" class="cs-redLabel">
          <el-col :span="12">
            <span>课程连报差价: </span>
            <span>-{{dataIn.workflowData.WorkflowRelatedDicountAmount | toCurrency}}</span>
          </el-col>
        </el-row>
        <el-row v-if="!!dataIn.workflowData.BonusPointCost" class="cs-redLabel">
          <el-col :span="12">
            <span>使用积分: </span>
            <span>-{{dataIn.workflowData.BonusPointCost}}{{dataIn.workflowData.BonusPointAmount | toCurrency}}</span>
          </el-col>
        </el-row>
        <el-row v-if="!!dataIn.workflowData.CashDecreasedAmount" class="cs-redLabel">
          <el-col :span="12">
            <span>现金减: </span>
            <span>-{{dataIn.workflowData.CashDecreasedAmount | toCurrency}}</span>
          </el-col>
        </el-row>
        <el-row v-if="!!dataIn.workflowData.CouponDiscountDollar" class="cs-redLabel">
          <el-col :span="12">
            <span>优惠劵: </span>
            <span>-{{dataIn.workflowData.CouponDiscountDollar | toCurrency}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <span>税前合计: </span>
            <span>{{ getAccountDiscountAmount() | toCurrency}}</span>
          </el-col>
        </el-row>
        <el-row v-if="dataIn.workflowData.IsDoubleBonusPoint">
          <el-col :span="12">
            <span>双倍积分</span>
          </el-col>
        </el-row>
        <el-row v-if="!!dataIn.workflowData.HasTax">
          <el-col :span="12">
            <span>税费(HST:{{ dataIn.workflowData.TaxRate | toPercent}}):</span>
            <span>{{getTotalTax() | toCurrency}}</span>
          </el-col>
        </el-row>
        <el-row v-if="!!dataIn.workflowData.AdvanceEnrollmentPrice">
          <el-col :span="12">
            <span>使用占位: </span>
            <span>{{((dataIn.workflowData.AdvanceEnrollmentPrice + dataIn.workflowData.AdvanceEnrollmentPriceTax)) | toCurrency}}</span>
          </el-col>
        </el-row>
        <el-row v-if="!!dataIn.workflowData.BalanceCost">
          <el-col :span="12">
            <span>使用余额: </span>
            <span>{{((dataIn.workflowData.BalanceCost + dataIn.workflowData.BalanceCostTax)) | toCurrency}}</span>
          </el-col>
        </el-row>
        <el-row v-if="!!dataIn.workflowData.TotalPayment">
          <el-col :span="12">
            <span>付款: </span>
            <span>{{dataIn.workflowData.TotalPayment | toCurrency}}</span>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-workflowDetails-container {
  padding: 20px;
  .cs-workflowDetails-title{
    text-align: center;
  }

  .cs-workflowDetails-discounts {
    margin-bottom: 0.5rem;
  }

  .cs-workflowDetails-courseEnrollmentList {
    padding: 0;
  }

  .cs-workflowDetails-workflowCostInfo{
    margin-top: 0.5rem;
  }
}
</style>

<script>
import courseEnrollmentList from "./courseEnrollmentList";
import { getCourseListData } from "@/service/enrollmentFee.service";
import { copyTextToClipboard, toDecimal } from "@/config/mUtils";

export default {
  props: {
    dataIn: {
      priceSettings: Object,
      memberModel: Object,
      studentAdvanceEnrollmentList: Array,
      workflowData: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      discountNames: "",
      courseType: 1,
      courseListData: {},
    };
  },
  components: {
    courseEnrollmentList,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.dataIn && this.dataIn.memberModel && this.dataIn.workflowData) {
        this.isLoading = true;
        if (
          this.dataIn.workflowData.WorkflowDiscounts &&
          this.dataIn.workflowData.WorkflowDiscounts.length > 0
        ) {
          this.discountNames = this.dataIn.workflowData.WorkflowDiscounts.map(
            (i) => i.FormulaFieldLabelName
          ).join(", ");
        } else {
          this.discountNames = "无优惠";
        }

        this.courseListData = getCourseListData(
          this.dataIn.workflowData,
          this.dataIn.memberModel,
          this.dataIn.studentAdvanceEnrollmentList
        );
        this.isLoading = false;
      }
    },
    getVisibleText(node) {
      let text = "";
      if (node.nodeType === Node.TEXT_NODE) {
        text = node.textContent;
        if (!!text) {
          text = text.trim();
        }

        if (!!text && text.length > 0) {
          if (text.indexOf(":") < 0) {
            text += ", ";
          } else {
            text += " ";
          }
        }

        return text;
      } else if (node.nodeType !== Node.ELEMENT_NODE) {
        return "";
      }
      let style = getComputedStyle(node);
      if (style && style.display === "none") {
        return "";
      }

      for (let i = 0; i < node.childNodes.length; i++) {
        text += this.getVisibleText(node.childNodes[i]);
      }

      return text;
    },
    onCopyInfo() {
      let discounts = `优惠: ${this.discountNames}, `;
      let courses = "";
      let courseList = document.getElementsByClassName(
        "cs-courseEnrollmentDetail-container-vertical"
      );
      for (let i = 0; i < courseList.length; i++) {
        let courseText = this.getVisibleText(courseList[i]);
        if (courses) {
          courses += "\r\n";
        }
        courses += `课程${i + 1} - ` + courseText;
      }

      let workflowCostInfo = this.getVisibleText(
        this.$refs.workflowCostInfo.$el
      );

      let txt = discounts + "\r\n" + courses + "\r\n" + workflowCostInfo;
      copyTextToClipboard(txt).then((result) => {
        if (result) {
          this.$message.success("复制成功");
        } else {
          this.$message.error("复制失败");
        }
      });
    },

    getAccountDiscountAmount() {
      let value = 0;
      if (!!this.dataIn && !!this.dataIn.workflowData) {
        let data = this.dataIn.workflowData;
        value = data.CourseDiscountTotalPrice - data.BonusPointAmount - data.CashDecreasedAmount - data.CouponDiscountDollar - data.WorkflowRelatedDicountAmount;
      }

      return toDecimal(value);
    },
    getTotalTax(){
      if (this.dataIn.workflowData){
        let value = this.getAccountDiscountAmount();
        let tax = value * this.dataIn.workflowData.TaxRate;
        return toDecimal(tax);
      }
      return 0;
    }
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/courseEnrollmentFee/workflowDetails.vue